module.exports = __webpack_public_path__ + "static/img/pad1.f205c229.png";